<div class="container-fluid">

    <div class="row">
        <div class="col-12">
            <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                <app-rp-breadcrumb [breadcrumbItems]="breadCrumbItems"></app-rp-breadcrumb>
                @if(cdkStepper.selectedIndex === 0 && currentUserData.currentUserRoleDetails.role ==
                this.Roles.ADMIN){<span class="breadcrumb m-0">
                    <button class="btn btn-primary d-flex align-items-center" (click)="UnitBalanceExportAll()">
                        <span class="fas fa-file-excel"> </span> &nbsp;Export All to Excel
                    </button>

                </span>}
                @if(cdkStepper.selectedIndex === 1){ <span class="breadcrumb m-0">
                    <button class="btn btn-primary d-flex align-items-center" (click)="exportAll()">
                        <span class="fas fa-file-excel"> </span> &nbsp;Export All to Excel
                    </button>

                </span>}
                @if(cdkStepper.selectedIndex === 2){<span class="breadcrumb m-0">
                    <button class="btn btn-primary d-flex align-items-center" (click)="SettlementexportAll()">
                        <span class="fas fa-file-excel"> </span> &nbsp;Export All to Excel
                    </button>

                </span>}
            </div>
        </div>
    </div>


    <div class="row">
        <div class="col-lg-12">
            <div class="card">
                <div class="card-body">
                    <ng-stepper #cdkStepper [linear]="false" class="wizard" (selectionChange)="tabChange($event)">

                        <cdk-step [optional]="false">
                            <ng-template cdkStepLabel>
                                <span class="number">1</span>
                                <span>Unit Balance</span>
                            </ng-template>
                            @if(cdkStepper.selectedIndex === 0){

                            <section class="p-2"
                                *ngIf="currentUserData.currentUserRoleDetails.role == this.Roles.CONSUMER">
                                <div class="card">
                                    <div class="card-body">
                                        <div class="card-body">
                                            <div class="row ">
                                                <div class="col-lg-3 mb-3">
                                                    <div class="mb-4">
                                                        <label for="basicpill-lastname-input">Residential Unit</label>
                                                        <p>{{consumerFlatDeatils?.flatNumbers}}</p>
                                                    </div>
                                                </div>
                                                <div class="col-lg-3 mb-3">
                                                    <div class="mb-4">
                                                        <label for="basicpill-lastname-input">Solar Balance
                                                            Units</label>
                                                        <p>{{consumerFlatDeatils?.solarBalanceUnits}}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </section>
                            <section class="" *ngIf="currentUserData.currentUserRoleDetails.role == this.Roles.ADMIN">
                                <ng-template #template let-anchor>
                                    <span>{{ anchor.nativeElement.innerText }}</span>
                                </ng-template>
                                <div kendoTooltip showOn="none" [tooltipTemplate]="template" filter=".k-grid td"
                                    (mouseover)="showTooltip($event)">
                                    <kendo-grid [data]="walletBalancegridData" [pageSize]="walletBalancepageSize"
                                        [skip]="walletBalanceSkip" [sortable]="true"
                                        [selectable]="selectableSettingsWalletBalance" [pageable]="{
                                            buttonCount: buttonCount,
                                            info: info,
                                            type: type,
                                            pageSizes: walletpageSizes,
                                            previousNext: WalletBalancepreviousNext
                                          }" [reorderable]="true" filterable="menu"
                                        [filter]="WalletBalanceState.filter" [sort]="WalletBalanceState.sort"
                                        [columnMenu]="{ filter: true }"
                                        (filterChange)="walletBalancewFilterChange($event)"
                                        (sortChange)="walletBalanceSortChange($event)" [resizable]="true"
                                        (pageChange)="walletBalancewPageChange($event)"
                                        (dataStateChange)="walletBalanceStateChange($event)"
                                        (selectionChange)="walletBalanceonSelect($event)">
                                        <ng-template kendoGridToolbarTemplate>
                                            <div class="search_icon">
                                                <kendo-textbox [style.width.px]="250" [style.height.px]="35"
                                                    [clearButton]="true"
                                                    (valueChange)="walletBalanceonValueChange($event)"
                                                    (keyup.enter)="walletBalanceSearchInvoicesAds()"
                                                    [style.height.px]="35" [(ngModel)]="triSourcesearchedValue"
                                                    placeholder="Search in all columns...">
                                                </kendo-textbox>

                                                <button class="btn btn-primary btn-md border-left-none"
                                                    (click)="walletBalanceonFilter($event)">
                                                    <i class="fa fa-search"></i>
                                                </button>
                                            </div>
                                            <kendo-grid-spacer></kendo-grid-spacer>

                                            <button class="btn btn-outline-primary btn-sm d-flex align-items-center"
                                                (click)="walletBalanceonExport('Excel')">
                                                <span class="fas fa-file-excel"></span> &nbsp; Export to Excel
                                            </button>

                                        </ng-template>

                                        <kendo-grid-checkbox-column [columnMenu]="false" [showSelectAll]="true"
                                            [width]="40" class="no-tooltip"></kendo-grid-checkbox-column>

                                        <kendo-grid-column field="consumerName"
                                            *ngIf="currentUserData.currentUserRoleDetails.role == this.Roles.ADMIN"
                                            title="Consumer Name"></kendo-grid-column>
                                        <kendo-grid-column field="flatNo" title="FlatNo"></kendo-grid-column>
                                        <kendo-grid-column field="extraUnits" title="Solar Balance Unit">
                                            <ng-template kendoGridCellTemplate let-dataItem>
                                                {{ dataItem.extraUnits }} KWh
                                            </ng-template></kendo-grid-column>



                                    </kendo-grid>
                                </div>
                                <!-- Excel Export -->
                                <div style="position: absolute; top: 0; left: -10000px; width: 500px;">
                                    <kendo-grid
                                        [kendoGridBinding]="walletBalanceselectedRowdata.length>0 ? walletBalanceselectedRowdata:walletBalancegridData.data"
                                        #walletBalancepdfGrid>
                                        <kendo-grid-column field="consumerName"
                                            *ngIf="currentUserData.currentUserRoleDetails.role == this.Roles.ADMIN"
                                            title="Consumer Name"></kendo-grid-column>
                                        <kendo-grid-column field="flatNo" title="FlatNo"></kendo-grid-column>
                                        <kendo-grid-column field="extraUnits" title=" Current Balance Unit">
                                            <ng-template kendoGridCellTemplate let-dataItem>
                                                {{ dataItem.extraUnits != null ? dataItem.extraUnits : '-' }}
                                            </ng-template>
                                        </kendo-grid-column>


                                        <kendo-grid-excel fileName="Unit Balance.xlsx"></kendo-grid-excel>
                                    </kendo-grid>
                                </div>
                            </section>

                            }
                        </cdk-step>
                        <cdk-step [optional]="false">
                            <ng-template cdkStepLabel>
                                <span class="number">2</span>
                                <span>Unit History </span>
                            </ng-template>
                            @if(cdkStepper.selectedIndex === 1){

                            <!-- wallet unit histry --> <ng-template #template let-anchor>
                                <span>{{ anchor.nativeElement.innerText }}</span>
                            </ng-template>
                            <div kendoTooltip showOn="none" [tooltipTemplate]="template" filter=".k-grid td"
                                (mouseover)="showTooltip($event)">
                                <kendo-grid [data]="walletUnitgridData" [pageSize]="walletUnitpageSize"
                                    [skip]="walletUnitSkip" [sortable]="true"
                                    [selectable]="selectableSettingswalletHistory" [pageable]="{
                                            buttonCount: buttonCount,
                                            info: info,
                                            type: type,
                                            pageSizes: walletUitpageSizes,
                                            previousNext: WalletpreviousNext
                                          }" [reorderable]="true" filterable="menu" [filter]="WalletUnitState.filter"
                                    [sort]="WalletUnitState.sort" [columnMenu]="{ filter: true }"
                                    (filterChange)="walletUnithistoryFilterChange($event)"
                                    (sortChange)="walletUnitSortChange($event)" [resizable]="true"
                                    (pageChange)="walletUitPageChange($event)"
                                    (dataStateChange)="walletunitStateChange($event)"
                                    (selectionChange)="walletUnitonSelect($event)">
                                    <ng-template kendoGridToolbarTemplate>
                                        <div class="search_icon">
                                            <kendo-textbox [style.width.px]="250" [style.height.px]="35"
                                                [clearButton]="true" (valueChange)="walletUnitonValueChange($event)"
                                                (keyup.enter)="walletUnitonSearchInvoicesAds()" [style.height.px]="35"
                                                [(ngModel)]="triSourcesearchedValue"
                                                placeholder="Search in all columns...">
                                            </kendo-textbox>

                                            <button class="btn btn-primary btn-md border-left-none"
                                                (click)="walletUitonFilter($event)">
                                                <i class="fa fa-search"></i>
                                            </button>
                                        </div>
                                        <kendo-grid-spacer></kendo-grid-spacer>

                                        <button class="btn btn-outline-primary btn-sm d-flex align-items-center"
                                            (click)="walletUnitonExport('Excel')">
                                            <span class="fas fa-file-excel"></span> &nbsp; Export to Excel
                                        </button>

                                    </ng-template>

                                    <kendo-grid-checkbox-column [columnMenu]="false" [showSelectAll]="true" [width]="40"
                                        class="no-tooltip"></kendo-grid-checkbox-column>

                                    <kendo-grid-column field="consumerName" title="Consumer Name"
                                        *ngIf="currentUserData.currentUserRoleDetails.role == this.Roles.ADMIN"></kendo-grid-column>
                                    <kendo-grid-column field="flatNo" title="FlatNo"></kendo-grid-column>
                                    <kendo-grid-column field="meterSerialNo"
                                        title="Device Sr No"></kendo-grid-column>
                                    <kendo-grid-column field="macAddress" title="Mac Address"></kendo-grid-column>

                                    <kendo-grid-column field="billNo" title="Bill No">
                                        <ng-template kendoGridCellTemplate let-dataItem>
                                            {{ dataItem.billNo ? dataItem.billNo : '-' }}
                                        </ng-template>
                                    </kendo-grid-column>
                                    <kendo-grid-column field="oldBalance" title="Old Units">
                                        <ng-template kendoGridCellTemplate let-dataItem>
                                            {{ dataItem.oldBalance }} KWh
                                        </ng-template>
                                    </kendo-grid-column>
                                    <kendo-grid-column field="newBalance" title="New Units">
                                        <ng-template kendoGridCellTemplate let-dataItem>
                                            {{ dataItem.newBalance }} KWh
                                        </ng-template>
                                    </kendo-grid-column>

                                    <kendo-grid-column field="createdOn" title="Bill Generated Date" filter="date">
                                        <ng-template kendoGridCellTemplate let-dataItem>
                                            {{ dataItem.createdOn | date: 'dd MMM yyyy' }}
                                        </ng-template>
                                    </kendo-grid-column>
                                    <kendo-grid-column field="currentBillGeneratedDate" title="Bill Date" filter="date">
                                        <ng-template kendoGridCellTemplate let-dataItem>
                                            {{ dataItem.currentBillGeneratedDate | date: 'dd MMM yyyy' }}
                                        </ng-template>
                                    </kendo-grid-column>
                                    <kendo-grid-column field="units" title="Adjusted Units" filter="numeric">
                                        <ng-template kendoGridCellTemplate let-dataItem>
                                            {{ dataItem.units }} KWh
                                        </ng-template>
                                    </kendo-grid-column>

                                    <kendo-grid-column field="transactionType" title="Unit Status">
                                        <ng-template kendoGridCellTemplate let-dataItem>
                                            <ng-container *ngIf="dataItem.transactionType !== undefined; else noStatus">
                                                <ng-container *ngIf="dataItem.transactionType === 'Debit'; else Credit">
                                                    <button type="button"
                                                        class="btn btn-soft-danger waves-effect waves-light">{{dataItem.transactionType}}</button>
                                                </ng-container>
                                                <ng-template #Credit>
                                                    <ng-container
                                                        *ngIf="dataItem.transactionType === 'Credit'; else NoChange">
                                                        <button type="button"
                                                            class="btn btn-soft-success waves-effect waves-light">{{dataItem.transactionType}}</button>
                                                    </ng-container>
                                                </ng-template>
                                                <ng-template #NoChange>
                                                    <button type="button"
                                                        class="btn waves-effect waves-light">{{dataItem.transactionType}}</button>
                                                </ng-template>
                                            </ng-container>
                                            <ng-template #noStatus>

                                                <span>No status</span>
                                            </ng-template>
                                        </ng-template>
                                    </kendo-grid-column>

                                </kendo-grid>
                            </div>
                            <!-- Excel Export -->
                            <div style="position: absolute; top: 0; left: -10000px; width: 500px;">
                                <kendo-grid
                                    [kendoGridBinding]="walletUitselectedRowdata.length>0 ? walletUitselectedRowdata:walletUnitgridData.data"
                                    #walletUnitpdfGrid>
                                    <kendo-grid-column field="consumerName" title="Consumer Name"
                                        *ngIf="currentUserData.currentUserRoleDetails.role == this.Roles.ADMIN"></kendo-grid-column>
                                    <kendo-grid-column field="flatNo" title="FlatNo"></kendo-grid-column>
                                    <kendo-grid-column field="billNo" title="Bill No"></kendo-grid-column>
                                    <kendo-grid-column field="meterSerialNo"
                                        title="Device Sr No"></kendo-grid-column>
                                    <kendo-grid-column field="macAddress" title="Mac Address"></kendo-grid-column>
                                    <kendo-grid-column field="oldBalance" title="Old Units">
                                    </kendo-grid-column>
                                    <kendo-grid-column field="newBalance" title="New units"></kendo-grid-column>
                                    <!-- <kendo-grid-column field="WalletAddedAmout"
                                        title="Amount Settled"></kendo-grid-column> -->

                                    <kendo-grid-column field="created_On" title="Bill Generated Date" filter="date">

                                    </kendo-grid-column>
                                    <kendo-grid-column field="currentBillGeneratedDate" title="Bill Date" filter="date">
                                    </kendo-grid-column>
                                    <kendo-grid-column field="units" title=" Adjusted Units"></kendo-grid-column>
                                    <!--  <kendo-grid-column field="UnitPrice" title="Units Rate"
                                        filter="numeric"></kendo-grid-column> -->

                                    <kendo-grid-column field="transactionType" title="Unit Status"></kendo-grid-column>
                                    <kendo-grid-excel fileName="Unit History.xlsx"></kendo-grid-excel>
                                </kendo-grid>
                            </div>

                            }
                        </cdk-step>
                        <cdk-step [optional]="false">
                            <ng-template cdkStepLabel>
                                <span class="number">3</span>
                                <span>Settlement Unit History </span>
                            </ng-template>
                            @if(cdkStepper.selectedIndex === 2){

                            <!-- settlement ubit history -->
                            <ng-template #template let-anchor>
                                <span>{{ anchor.nativeElement.innerText }}</span>
                            </ng-template>
                            <div kendoTooltip showOn="none" [tooltipTemplate]="template" filter=".k-grid td"
                                (mouseover)="showTooltip($event)">
                                <kendo-grid [data]="TriSourceSettlementgridData" [pageSize]="pageSize"
                                    [skip]="trisourceSettlementSkip" [sortable]="true" [selectable]="selectableSettings"
                                    [pageable]="{
                                            buttonCount: buttonCount,
                                            info: info,
                                            type: type,
                                            pageSizes: pageSizes,
                                            previousNext: previousNext
                                          }" [reorderable]="true" filterable="menu" [filter]="trisourceState.filter"
                                    [sort]="trisourceState.sort" [columnMenu]="{ filter: true }"
                                    (filterChange)="triSourceSettlementFilterChange($event)"
                                    (sortChange)="onSortChange($event)" [resizable]="true"
                                    (pageChange)="trisourceSettlementPageChange($event)"
                                    (dataStateChange)="trisourceStateChange($event)"
                                    (selectionChange)="onSelect($event)">
                                    <ng-template kendoGridToolbarTemplate>
                                        <div class="search_icon">
                                            <kendo-textbox [style.width.px]="250" [style.height.px]="35"
                                                [clearButton]="true" (valueChange)="onValueChange($event)"
                                                (keyup.enter)="onSearchInvoicesAds()" [style.height.px]="35"
                                                [(ngModel)]="triSourcesearchedValue"
                                                placeholder="Search in all columns...">
                                            </kendo-textbox>

                                            <button class="btn btn-primary btn-md border-left-none"
                                                (click)="onFilter($event)">
                                                <i class="fa fa-search"></i>
                                            </button>
                                        </div>
                                        <kendo-grid-spacer></kendo-grid-spacer>


                                        <button class="btn  btn-outline-primary btn-sm"
                                            *ngIf="currentUserData.currentUserRoleDetails.role == this.Roles.ADMIN"
                                            (click)="openSettlement(addUmd)">Settle
                                            Now

                                        </button>
                                        <button class="btn btn-outline-primary btn-sm d-flex align-items-center"
                                            (click)="onExport()">
                                            <span class="fas fa-file-excel"></span> &nbsp; Export to Excel
                                        </button>

                                    </ng-template>

                                    <kendo-grid-checkbox-column [columnMenu]="false" [showSelectAll]="true" [width]="40"
                                        class="no-tooltip"></kendo-grid-checkbox-column>

                                    <kendo-grid-column field="consumerName" title="Consumer Name"
                                        *ngIf="currentUserData.currentUserRoleDetails.role == this.Roles.ADMIN"></kendo-grid-column>
                                    <kendo-grid-column field="flatNo" title="FlatNo"></kendo-grid-column>
                                    <kendo-grid-column field="meterSerialNo"
                                        title="Device Sr No"></kendo-grid-column>
                                    <kendo-grid-column field="macAddress" title="Mac Address"></kendo-grid-column>
                                    <kendo-grid-column field="oldBalance" title="Old Units">
                                        <ng-template kendoGridCellTemplate let-dataItem>
                                            {{ dataItem.oldBalance }} KWh
                                        </ng-template>
                                    </kendo-grid-column>
                                    <kendo-grid-column field="newBalance" title="New Units">
                                        <ng-template kendoGridCellTemplate let-dataItem>
                                            {{ dataItem.newBalance }} KWh
                                        </ng-template>
                                    </kendo-grid-column>
                                    <kendo-grid-column field="walletAddedAmout" title="Amount Settled" filter="numeric">
                                        <ng-template kendoGridCellTemplate let-dataItem>
                                            {{ dataItem.walletAddedAmout | currency: 'INR':'symbol':'1.2-2' }}
                                        </ng-template>
                                    </kendo-grid-column>

                                    <kendo-grid-column field="createdOn" title="Settlement Date " filter="date">
                                        <ng-template kendoGridCellTemplate let-dataItem>
                                            {{ dataItem.createdOn | date: 'dd MMM yyyy hh:mm a' }}
                                        </ng-template>
                                    </kendo-grid-column>

                                    <kendo-grid-column field="units" title="Units Deducted" filter="numeric">
                                        <ng-template kendoGridCellTemplate let-dataItem>
                                            {{ dataItem.units }} KWh
                                        </ng-template></kendo-grid-column>
                                    <kendo-grid-column field="unitPrice" title="Unit Rate" filter="numeric">
                                        <ng-template kendoGridCellTemplate let-dataItem>
                                            {{ dataItem.unitPrice | currency: 'INR':'symbol':'1.2-2' }}
                                        </ng-template>

                                    </kendo-grid-column>
                                    <kendo-grid-column field="settlementType" title="Settlement Type">

                                    </kendo-grid-column>


                                </kendo-grid>
                            </div>
                            <!-- Excel Export -->
                            <div style="position: absolute; top: 0; left: -10000px; width: 500px;">
                                <kendo-grid
                                    [kendoGridBinding]="selectedRowdata.length>0 ? selectedRowdata:TriSourceSettlementgridData.data"
                                    #pdfGrid>
                                    <kendo-grid-column field="consumerName" title="Consumer Name"
                                        *ngIf="currentUserData.currentUserRoleDetails.role == this.Roles.ADMIN"></kendo-grid-column>
                                    <kendo-grid-column field="flatNo" title="FlatNo"></kendo-grid-column>
                                    <kendo-grid-column field="meterSerialNo"
                                        title="Device Sr No"></kendo-grid-column>
                                    <kendo-grid-column field="macAddress" title="Mac Address"></kendo-grid-column>
                                    <!-- <kendo-grid-column field="billNo" title="Bill No"></kendo-grid-column> -->
                                    <kendo-grid-column field="oldBalance" title="Old Units">
                                    </kendo-grid-column>
                                    <kendo-grid-column field="newBalance" title="New units"></kendo-grid-column>
                                    <kendo-grid-column field="walletAddedAmout" title="Amount Settled">
                                    </kendo-grid-column>

                                    <kendo-grid-column field="created_Date" title="Settlement Date">
                                    </kendo-grid-column>
                                    <kendo-grid-column field="units" title="Units Deducted"></kendo-grid-column>
                                    <kendo-grid-column field="unitPrice" title="Unit Rate"
                                        filter="numeric"></kendo-grid-column>

                                    <kendo-grid-column field="settlementType"
                                        title="Settlement Type"></kendo-grid-column>

                                    <kendo-grid-excel fileName="Settlement Unit History.xlsx"></kendo-grid-excel>
                                </kendo-grid>
                            </div>

                            }
                        </cdk-step>
                    </ng-stepper>
                </div>
            </div>
        </div>
    </div>


</div>



<ng-template #addUmd>
    <div class="modal-header ">
        <h5 class="modal-title">TriSource Settlement</h5>
        <button type="button" class="btn-close text-white" data-bs-dismiss="modal" aria-label="Close"
            (click)="modelRef_1.hide()"></button>
    </div>
    <div class="modal-body">

        <form class="form-horizontal" [formGroup]="consumerForm">
            <div class="row">
                <div class="col-lg-12 mb-3">
                    <label>Consumers<span class="required">*</span></label>
                    <ng-select [items]="ConsumerList" formControlName="ConsumerIDs" [(ngModel)]="selectedConsumers"
                        (change)="ConsumersChange($event)" bindLabel="userName" bindValue="id" [multiple]="true"
                        [placeholder]="'Select...'" (add)="onSelectConsumers($event)" [deselectOnClick]="true">


                        <!-- Template for displaying selected items with cross icon -->
                        <ng-template ng-label-tmp let-item="item" let-clear="clear">
                            <span class="ng-value-label">{{ item?.userName }}</span>
                            <!-- Cross icon to clear the selected item -->
                            <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                        </ng-template>

                        <!-- Multi-label template for displaying multiple selected items -->
                        <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                            <div class="ng-value" *ngFor="let item of items.slice(0, 2)">
                                <span class="ng-value-label" *ngIf="item?.userName">{{ item?.userName }}</span>
                                <!-- Cross icon for removing items -->
                                <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                            </div>
                            <div class="ng-value" *ngIf="items.length > 2">
                                <span class="ng-value-label">+ {{ items.length - 2 }} more</span>
                            </div>
                        </ng-template>


                    </ng-select>
                    @if((Submitted || ConsumerControls['ConsumerIDs'].touched) &&
                    ConsumerControls['ConsumerIDs'].errors){

                    <div class="invalid-feedback">
                        @if(ConsumerControls['ConsumerIDs'].errors['required']){
                        <div>{{projectValidations.consumer_required}}</div>
                        }
                    </div>}

                </div>
                <div class="col-lg-12 mb-3">
                    <input class="form-check-input" type="checkbox" (change)="onCheckboxChange($event)"
                        formControlName="UnitRate" id="formCheck1">
                    <label class="form-check-label" for="formCheck1"> &nbsp; Enter Unit Rate Manually </label>

                </div>
                <div class=" col-lg-8 mb-3" *ngIf="ConsumerControls['UnitRate'].value == true">
                    <!--  <label for="unitPrice">Unit Price (1 m³/ LPG (In Rs))<span class="required">*</span></label> -->
                    <input type="text" class="form-control disabled" id="unitPrice" placeholder="Enetr unit Rate"
                        formControlName="unitPrice">
                    @if((Submitted || ConsumerControls['unitPrice'].touched) && ConsumerControls['unitPrice'].errors){

                    <div class="invalid-feedback">
                        @if(ConsumerControls['unitPrice'].errors['required']){
                        <div>{{projectValidations.required}}</div>
                        }
                        @if(consumerForm.get('unitPrice')?.errors?.['maxValue']) {
                        <div>{{ projectValidations.maxlimit }}</div>
                        }
                        @if(consumerForm.get('unitPrice')?.errors?.['pattern']) {
                        <div>{{projectValidations.patterenvaliadation}}</div>}

                    </div>}

                </div>
            </div>
        </form>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-primary waves-effect waves-light" (click)="SettleNow()">Settle Now</button>
    </div>

</ng-template>